module.exports = __webpack_public_path__ + "static/media/arrow.1e102ab2.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/arrow.svg
 ** module id = 162
 ** module chunks = 0
 **/